var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.text)?_c('b-button',{attrs:{"variant":"light","size":"sm"},domProps:{"innerHTML":_vm._s(_vm.btnContent)},on:{"click":_vm.onClick}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }